var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idea-score-card-pill p-2 text-center",class:_vm.isFullyCompleted ? 'fully-completed' : 'partially-completed'},[_c('span',{staticClass:"text-lowercase"},[_vm._v(" "+_vm._s(_vm.completedStepsCount)+"/"+_vm._s(_vm.totalStepsCount)+" "+_vm._s(_vm.$t('completed'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }